<template>
    <ContainerContent
        class="mb-8 mt-6"
        max-class="max-w-sm-ceil"
        outer-container
    >
        <v-row>
            <v-col class="text-center">
                <img
                    :src="`${cdnBasePathMain}/static/common/images/svg/other/durability-guarantee.svg`"
                />
            </v-col>
        </v-row>
        <v-row>
            <v-col class="text-center">
                <h3
                    class="text-display-medium py-0 my-0"
                >
                    A Better Warranty Program.
                </h3>
            </v-col>
        </v-row>
        <v-row>
            <v-col
                class="text-center"
            >
                <p>
                    Our goal is to develop the highest-performing products, backed by the best shopping experience and customer service available. That's why we created a fast and easy warranty replacement program to help get you back out on the field.
                </p>
                <v-btn
                    to="/account/claims?open-form"
                    class="mt-6"
                    color="secondary"
                >
                    Submit A Claim
                </v-btn>
                <p>
                    * Requires an account, please <NuxtLink to="/account/claims?open-form">Sign in</NuxtLink> or <NuxtLink to="/create-account">Create an account</NuxtLink>.
                </p>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-divider
                    class="my-8"
                ></v-divider>
            </v-col>
        </v-row>
        <v-row
            v-if="!hideForResellers"
        >
            <v-col>
                <h4
                    class="text-headline-large py-0 my-0"
                >
                    FAST.
                </h4>
                <p>
                    Submit a claim and receive a new product in as little as 2–3 days.
                </p>
            </v-col>
            <v-col>
                <h4
                    class="text-headline-large py-0 my-0"
                >
                    EASY.
                </h4>
                <ol>
                    <li>Submit a claim</li>
                    <li>Choose your replacement</li>
                    <li>Receive it in 2–3 days</li>
                </ol>
            </v-col>
            <v-col>
                <h4
                    class="text-headline-large font-weight-bold py-0 my-0"
                >
                    FREE.
                </h4>
                <p>
                    Receive your replacement via expedited shipping for free.
                </p>
            </v-col>
        </v-row>
        <v-row
            class="my-8 px-4"
        >
            <v-col
                class="text-center"
            >
                <h4
                    class="text-headline-large py-0 my-0"
                >
                    Questions?
                </h4>
                <p>
                    Contact us at
                    <a
                        :href="`mailto:returns@${fqdn}`"
                    >
                        returns@{{fqdn}}
                    </a>
                    or <a
                        :href="`tel:${mainContactPhoneNumber}`"
                    >
                        {{ mainContactPhoneNumberFormatted }}
                    </a>
                </p>
            </v-col>
        </v-row>
    </ContainerContent>
</template>

<script lang="ts" setup>
    import ContainerContent from '~/components/ContainerContent/ContainerContent.vue';
    import {
        useCdnResource
    } from 'x1-base/composables';

    definePageMeta({
        scrollToTop: true,
        alias: [
            '/support/warranty/submit-claim'
        ]
    });

    const $config = useRuntimeConfig();
    const {
        title: brandTitle,
        mainContactPhoneNumberFormatted,
        mainContactPhoneNumber,
        fqdn
    } = $config.public.brand;

    useHead({
        title: `Warranty | ${brandTitle}`,
        meta: [
            {
                name: 'description',
                content: 'Warranty'
            }
        ]
    });

    const nuxtApp = useNuxtApp();
    const {
        getIsReseller
    } = nuxtApp.$user;
    const { cdnBasePathMain } = useCdnResource();
    const hideForResellers = ref<boolean>(getIsReseller());
</script>

<style lang="scss"></style>
